import { styled } from '@/stitches/index.js';

export const StyledTextFieldMenu = styled('div', {
  left: '0',
  position: 'absolute',
  top: 'calc(100% + $2)',
  width: '100%',
  zIndex: '$menu',
});
